import { render, staticRenderFns } from "./Mouth4.vue?vue&type=template&id=b74438ba&"
import script from "./Mouth4.vue?vue&type=script&lang=js&"
export * from "./Mouth4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports